/**
 * Mega menú Armonía — activar panel al click/hover y al abrir popup.
 * Complementa popup-menu.js del tema (mouseover; links con submenú no deben navegar).
 *
 * Perf: los paneles visuales están en DOM pero ocultos (display:none) → las imágenes
 * solo se pedían al activar la sección (lag al cambiar Guitarras→Percusión…).
 * Prefetch al hover + tope de ancho al revelar.
 */
(function () {
  var PREFETCH_W_CARD = 640;
  var PREFETCH_W_HERO = 720;

  function activateListItem(listItem) {
    if (!listItem) return;
    document.querySelectorAll('.popup-menu__list-item, .popup-menu__submenu-item').forEach(function (el) {
      el.classList.remove('active');
    });
    listItem.classList.add('active');
    var nested = listItem.querySelector('.popup-menu__submenu-item.popup-menu__has-submenu');
    if (nested) nested.classList.add('active');
    prefetchPanel(listItem);
    revealPanelImages(listItem);
  }

  function masterUrl(img, width) {
    if (!img || !img.dataset.master) return '';
    var url = img.dataset.master.replace('{width}', String(width));
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url;
  }

  function prefetchPanel(listItem) {
    if (!listItem || listItem.dataset.armoniaPrefetch === '1') return;
    if (!listItem.querySelector('.popup-menu__submenu--armonia-visual')) return;
    listItem.dataset.armoniaPrefetch = '1';
    listItem.querySelectorAll('.popup-menu__submenu--armonia-visual [data-master]').forEach(function (img) {
      var kind = img.getAttribute('data-armonia-menu-img');
      var w = kind === 'hero' ? PREFETCH_W_HERO : PREFETCH_W_CARD;
      var url = masterUrl(img, w);
      if (!url) return;
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = url;
    });
  }

  function revealPanelImages(listItem) {
    if (!listItem || !window.lazyImages) return;
    requestAnimationFrame(function () {
      listItem.querySelectorAll('.popup-menu__submenu--armonia-visual [data-master]').forEach(function (img) {
        var kind = img.getAttribute('data-armonia-menu-img');
        var w = kind === 'hero' ? PREFETCH_W_HERO : PREFETCH_W_CARD;
        if (img.dataset.currentWidth && Number(img.dataset.currentWidth) >= w) return;
        try {
          window.lazyImages.setProperties(img, w);
        } catch (e) {
          /* ignore */
        }
      });
    });
  }

  function activateFirstSubmenu(menu) {
    var first = menu.querySelector('.popup-menu__list-item.popup-menu__has-submenu');
    activateListItem(first);
  }

  function onMenuClick(e) {
    var listItem = e.target.closest('.popup-menu__list-item.popup-menu__has-submenu');
    if (!listItem) return;

    var link = e.target.closest('.popup-menu__link');
    if (!link || !listItem.contains(link)) return;

    e.preventDefault();
    activateListItem(listItem);
  }

  function onMenuHover(e) {
    var listItem = e.target.closest('.popup-menu__list-item.popup-menu__has-submenu');
    if (!listItem) return;
    prefetchPanel(listItem);
  }

  function onWrapActive(wrap, menu) {
    if (!wrap.classList.contains('active')) return;
    if (!wrap.querySelector('.popup-menu__list-item.active')) {
      activateFirstSubmenu(menu);
    } else {
      var active = wrap.querySelector('.popup-menu__list-item.active');
      prefetchPanel(active);
      revealPanelImages(active);
    }
  }

  function init() {
    var menu = document.getElementById('jsPopupMenu');
    var wrap = document.getElementById('jsPopupMenuWrapper');
    var btn = document.querySelector('.js-popup-menu-button');
    if (!menu || !wrap || !btn) return;

    menu.addEventListener('click', onMenuClick, true);
    menu.addEventListener('mouseover', onMenuHover, true);

    btn.addEventListener('click', function () {
      setTimeout(function () {
        onWrapActive(wrap, menu);
      }, 50);
      setTimeout(function () {
        onWrapActive(wrap, menu);
      }, 250);
    });

    var observer = new MutationObserver(function () {
      onWrapActive(wrap, menu);
    });
    observer.observe(wrap, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
